import React from "react";
import "./CustomCheckbox.scss";

const CustomCheckbox = ({
  id,
  className,
  text,
  checked,
  onChange,
  checkboxClassName,
}) => {
  return (
    <label class={`custom-checkbox ${checkboxClassName}`}>
      <label htmlFor={id} className={className}>
        {text}
      </label>
      <input type="checkbox" id={id} checked={checked} onChange={onChange} />
      <span class="checkmark" />
    </label>
  );
};

export default CustomCheckbox;
